import styled from '@emotion/styled';
import { globalVariables } from '../../../shared/designSystem/constants';

import { useDetermineMobile } from '@myrealtrip/device-detect';
import Copyright from './Copyright';
import ISMS from './ISMS';
import LanguageSelector from './LanguageSelector';
import OutLinkContainer from './OutLinkContainer';
import PolicyList from './PolicyList';

export default function FooterBottomBox() {
  const isMobile = useDetermineMobile();

  const Container = isMobile ? MobileContainer : DesktopContainer;
  const TopBox = isMobile ? MobileTopBox : DesktopTopBox;
  const BottomBox = isMobile ? MobileBottomBox : DesktopBottomBox;

  return (
    <Container>
      <TopBox>
        <PolicyList />
        {isMobile && (
          <BottomBox>
            <Copyright />
            <ISMS />
          </BottomBox>
        )}
        <OutLinkContainer />
        <LanguageSelector />
      </TopBox>
      {!isMobile && (
        <BottomBox>
          <Copyright />
          <ISMS />
        </BottomBox>
      )}
    </Container>
  );
}

const CommonContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const MobileContainer = styled(CommonContainer)`
  padding-top: 0;
  border-top: 0;
`;

const DesktopContainer = styled(CommonContainer)`
  padding-top: 16px;
  border-top: 1px solid ${globalVariables.gray_100};
`;

const CommonTopBox = styled.div`
  display: flex;
`;

const MobileTopBox = styled(CommonTopBox)`
  flex-direction: column;
`;

const DesktopTopBox = CommonTopBox;

const CommonBottomBox = styled.div`
  display: flex;
`;

const MobileBottomBox = styled(CommonBottomBox)`
  flex-direction: column;
  margin-bottom: 24px;
`;

const DesktopBottomBox = CommonBottomBox;
